module.exports = __webpack_public_path__ + "img/download.6dba70eb.svg";